import React, { useMemo, useState, useEffect } from "react";
import { Button, Divider } from "antd";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom";
import qs from "qs";

import {
  AxiosCustomPost,
  AxiosCustomGet,
} from "../../../../components/axios/AxiosCustom";
import Config from "../../../../components/axios/Config";
import AppRoutePath from "../../../../router/AppRoutePath";
import Breadcrumb from "../../../../components/common/Breadcrumb/Breadcrumb";
import PreviewImage from "../../../../components/common/PreviewImage/PreviewImage";
import RejectDialog from "../../../../components/common/RejectDialog/RejectDialog";
import Title from "../../../../components/common/Title/Title";
import SwalToast from "../../../../components/helpers/SwalToast";
import HeaderInfo from "../../../finance/report/pawn_transaction/components/GadaiReportDetail/HeaderInfo";
import LoanInfo from "../components/ProcessLoan/components/LoanInfo";
import LoanSummary from "../components/ProcessLoan/components/LoanSummary";
import ProcessDialog from "../components/ProcessLoan/components/ProcessDialog";

import { convertBankList } from "../../../../components/helpers/convertBankList";
import { convertProcessLoanData } from "./ProcessLoan/helpers/convertProcessLoanData";

import { initProcessData } from "../../constants";
import {
  AuthorizationList,
  CanAccess,
} from "../../../../components/template/authorization/Authorization";

const ProcessLoanPage = () => {
  const history = useHistory();
  const [loanData, setLoanData] = useState({});
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [isRejectDialogOpen, setIsRejectDialogOpen] = useState(false);
  const [imgLink, setImgLink] = useState("");
  const [errors, setErrors] = useState({});
  const [transferProofImg, setTransferProofImg] = useState([]);
  const [isProcessDialogOpen, setIsProcessDialogOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [bankList, setBankList] = useState([]);
  const [processData, setProcessData] = useState(initProcessData);
  const [selectedID, setSelectedID] = useState("");

  const breadCrumbItems = useMemo(() => {
    return [
      {
        text: "Permohonan Gadai Non-tunai (Transfer)",
        link: "/loan-noncash",
      },
    ];
  }, []);

  const getBankList = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}bank`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setBankList(convertBankList(response.data.data));
      }
    );
  };

  const getProcessLoanSummary = () => {
    const tempLoanData = history?.location?.state?.data;
    let url = `${process.env.REACT_APP_BASE_API_URL}transaction`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        {
          receipt_code: tempLoanData.receiptNumber,
        },
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      ),
      (response) => {
        setSelectedID(tempLoanData.gadaiID);
        setLoanData(
          convertProcessLoanData(
            tempLoanData,
            response.data.data,
            handleOpenPreview
          )
        );
      }
    );
  };

  const handleTextInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "reason") {
      setReason(value);
      if (errors.reason) {
        setErrors({});
      }
    }
  };

  const handleSelectChange = (field, data) => {
    if (field === "bankName") {
      setProcessData((prev) => ({
        ...prev,
        [field]: {
          value: data.value,
          label: data.label,
        },
      }));
    }

    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: null,
      }));
    }
  };

  const handleOpenPreview = (src) => () => {
    setImgLink(src);
    setIsPreviewOpen(true);
  };

  const handleCancel = () => {
    setIsRejectDialogOpen(false);
    setIsProcessDialogOpen(false);

    if (errors) {
      setErrors({});
    }
  };

  const validateReject = () => {
    const newErrors = {};

    if (!reason || reason === "") {
      newErrors.reason = "Alasan tidak boleh kosong";
    }
    return newErrors;
  };

  const handleRejectSave = () => {
    const newErrors = validateReject();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    } else {
      const data = {
        notes: reason,
      };

      let url = `${process.env.REACT_APP_BASE_API_URL}gadai/${selectedID}/disburse-cancel`;
      AxiosCustomPost(
        url,
        data,
        Config({
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        }),
        () => {
          SwalToast.fire({
            icon: "success",
            title: "Sukses Membatalkan Proses Pinjaman",
          });
          history.push(AppRoutePath.LOAN_NONCASH);
        },
        (error) => {
          if (error.response) {
            SwalToast.fire({
              icon: "error",
              title: `Gagal Membatalkan Proses Pinjaman: ${error?.response?.data?.error?.message}`,
            });
          } else {
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        },
        () => {
          setIsRejectDialogOpen(false);
          setReason("");
        }
      );
    }
  };

  const handleProcessSave = () => {
    const newErrors = validateProcess(processData);

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    } else {
      const data = {
        transfer_proof_picture: processData.transferProof,
        bank: processData.bankName.label,
      };

      let url = `${process.env.REACT_APP_BASE_API_URL}gadai/${selectedID}/disburse-transfer`;
      AxiosCustomPost(
        url,
        data,
        Config({
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        }),
        () => {
          SwalToast.fire({
            icon: "success",
            title: "Sukses Mengirim Pinjaman",
          });
          history.push(AppRoutePath.LOAN_NONCASH);
        },
        (error) => {
          if (error.response) {
            SwalToast.fire({
              icon: "error",
              title: `Gagal Mengirim Pinjaman: ${error?.response?.data?.error?.message}`,
            });
          } else {
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        },
        () => {
          setIsProcessDialogOpen(false);
          setProcessData(initProcessData);
          setTransferProofImg([]);
        }
      );
    }
  };

  const handleViewSBG = () => {
    history.push(`/sbg-private/${selectedID || 0}`);
  };

  const handleViewDetail = () => {
    history.push(`/report/pawn/${selectedID || 0}`);
  };

  const handleUploadImage = (type) => (options) => {
    const { onSuccess, onError, file } = options;

    const fmData = new FormData();
    fmData.append("file", file);

    let url = `${process.env.REACT_APP_BASE_API_URL}upload-image`;
    AxiosCustomPost(
      url,
      fmData,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
        "content-type": "multipart/form-data",
      }),
      (response) => {
        onSuccess(response.data.data, file);
        setProcessData((prev) => ({
          ...prev,
          transferProof:
            type === "transferProof"
              ? response.data.data.object_path
              : prev.transferProof,
        }));
      },
      (error) => {
        onError({ error });
      }
    );
  };

  const handleImageChange =
    (type) =>
    ({ fileList }) => {
      let tempFileList = [...fileList];
      tempFileList = tempFileList.slice(-1);

      tempFileList = tempFileList.map((file) => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });
      if (type === "transferProof") {
        setTransferProofImg(tempFileList);
      }
      if (errors[type]) {
        setErrors((prev) => ({
          ...prev,
          [type]: null,
        }));
      }
    };

  const validateProcess = (data) => {
    const newErrors = {};

    if (!data.bankName || data.bankName === "") {
      newErrors.bankName = "Bank harus dipilih";
    }
    if (!data.transferProof || data.transferProof === "") {
      newErrors.transferProof = "Bukti transfer harus diupload";
    }
    return newErrors;
  };

  useEffect(() => {
    getBankList();
    getProcessLoanSummary();
  }, []);

  return (
    <div>
      <div className="px-3">
        <div className="py-4 d-flex flex-column" style={{ fontSize: "13px" }}>
          <Title text={"Pinjaman Non-tunai (Transfer)"} />
          <Breadcrumb
            breadCrumbItems={breadCrumbItems}
            current={"Proses Pinjaman"}
          />
        </div>

        <div className="d-flex justify-content-end button-action-container">
          <CanAccess
            role={AuthorizationList.view_gadai}
            yes={
              <div>
                <Button
                  key="submit"
                  type="primary"
                  onClick={handleViewSBG}
                  className={"loan-btn-action loan-btn-warning"}
                >
                  Lihat SBG
                </Button>
              </div>
            }
          />
          <div>
            <Button
              key="submit"
              type="primary"
              danger
              onClick={() => setIsRejectDialogOpen(true)}
              className="loan-btn-action loan-btn-danger"
            >
              Batalkan
            </Button>
          </div>
          <div>
            <Button
              key="submit"
              type="primary"
              onClick={() => setIsProcessDialogOpen(true)}
              className={"loan-btn-action"}
            >
              Cairkan Pinjaman
            </Button>
          </div>
        </div>

        <div
          className="detail-card-container"
          style={{ border: "1px solid #DCDCDC" }}
        >
          <div className="d-flex">
            <HeaderInfo
              gadaiID={selectedID}
              data={{
                commonInfo: loanData.commonInfo,
                headerInfo: loanData.headerInfo,
              }}
            />
          </div>
          <div style={{ width: "55%", marginRight: "20px" }}>
            <Divider dashed className="detail-divider" />
          </div>
          <div className="d-flex flex-row">
            <div style={{ flex: "1 1 60%", marginRight: "20px" }}>
              <LoanInfo data={loanData.loanInfo} />
            </div>
            <div style={{ flex: "1 1 40%" }}>
              <LoanSummary data={loanData.loanSummary} />
            </div>
          </div>
          <div style={{ marginTop: "20px" }}>
            <Button
              key="submit"
              type="primary"
              onClick={handleViewDetail}
              className={"loan-btn-action"}
            >
              Lihat Detail Gadai
            </Button>
          </div>
        </div>
      </div>

      <PreviewImage
        visible={isPreviewOpen}
        setVisible={setIsPreviewOpen}
        url={imgLink}
      />

      <RejectDialog
        visible={isRejectDialogOpen}
        handleCancel={handleCancel}
        handleSave={handleRejectSave}
        hasCancel
        isDangerButton
        actionButtonText={"Batalkan"}
        title={"Batalkan Proses Pinjaman"}
        handleChange={handleTextInputChange}
        errors={errors}
        reasonValue={reason}
        isStyleBlock
      />

      <ProcessDialog
        visible={isProcessDialogOpen}
        handleCancel={handleCancel}
        handleSave={handleProcessSave}
        actionButtonText={"Kirim"}
        title={"Proses Pinjaman"}
        onSelectChange={handleSelectChange}
        errors={errors}
        data={processData}
        summaryData={loanData}
        bankOptions={bankList}
        onImageChange={handleImageChange}
        handleUploadImage={handleUploadImage}
        transferProofImg={transferProofImg}
      />
    </div>
  );
};

export default ProcessLoanPage;
